
export const API_CONFIG = {
  port: 9100,
  host: "cwapibknd.onrender.com",
  fetchCourse: {
    method: "GET",
    path: "/courseDetails/fetchCourses",
  },

  fetchPuzzlesByTopic: {
    method: "GET",
    path: "/courseDetails/fetchPuzzlesByTopic",
  },

  solvePuzzle: {
    method: "POST",
    path: "/courseDetails/solvePuzzle",
  },

  fetchUserInfo: {
    method: "GET",
    path: "/logindetails/fetchUserInfo",
  },
  fetchPuzzleInfo: {
    method: "GET",
    path: "/courseDetails/addPuzzleInfo",
  },
  fetchLatestPuzzle: {
    method: "GET",
    path: "/courseDetails/fetchLatestPuzzle",
  },
  addPuzzle: {
    method: "POST",
    path: "/courseDetails/addPuzzle",
  },
  addTournament: {
    method: "POST",
    path:  "/tournamentDetails/addTournament",
  },
  fetchTournaments: {
    method: "GET",
    path: "/tournamentDetails/fetchTournaments",
  },
  fetchResults: {
    method: "GET",
    path: "/tournamentDetails/fetchResults",
  },
  sendDemoRegisteration:{
    method: "POST",
    path: "/email/sendDemoRegisteration",
  },
  contactUs:{
    method: "POST",
    path: "/email/contactUs",
  },
  fetchTournamentById: {
    method: "GET",
    path: (tournamentID) =>
      `/TournamentDetails/FetchTournamentById/${tournamentID}`,
  },
  updateTournament: {
    method: "PATCH",
    path:(tournamentID)=>
      `/TournamentDetails/updateTournament/${tournamentID}`
  },
  deleteTournament: {
    method: "GET",
    path:(tournamentID)=>
      `/TournamentDetails/deleteTournamentById/${tournamentID}`
  },
    fetchResultById: {
    method: "GET",
    path: (resultID) =>
      `/TournamentDetails/FetchResultById/${resultID}`,
  },
   googleLogin: {
    path: "/logindetails/auth/google",
  },

  microsoftLogin: {
    path: "/logindetails/auth/microsoft",
  },
  fetchMe: {
    method: "GET",
    path: "/logindetails/auth/me",
  },
  logout: {
    path: "/logindetails/logout",
  },
  basic:{
    BASIC_AUTH_ADMIN:"YWRtaW5Vc2VyOmNod2FkbWlu",
    BASIC_AUTH_CWUSER:"Y3dVc2VyOmNod3VzZXI="
  },
  hmac:{
    HASHKEY_ADMIN: "bxd657uh",
    HASHKEY_CW_USER: "fjfkh85jh"
  },
  userRanking:{
    method: "GET",
    path: "/logindetails/fetchUserRankings"
  },
  fetchAlerts: {
    method: "GET",
    path: "/alerts/fetchAlerts",
  },
  addAlert: {
    method: "POST",
    path: "/alerts/addAlert",
  },
  updateName:{
    method:"PATCH",
    path:"/logindetails/updateUserName"
  }
};
